export const ClientRole = {
  MASTER_ADMIN: { key: 'MASTER_ADMIN', label: '대표 관리자' },
  ADMIN: { key: 'ADMIN', label: '관리자' },
  NORMAL: { key: 'NORMAL', label: '일반' },
} as const;

export type ClientRole = keyof typeof ClientRole;

export const VendorRole = {
  MASTER_ADMIN: { key: 'MASTER_ADMIN', label: '대표 관리자' },
  ADMIN: { key: 'ADMIN', label: '관리자' },
  NORMAL: { key: 'NORMAL', label: '일반' },
} as const;

export type VendorRole = keyof typeof VendorRole;
